export default __webpack_public_path__ + "static/media/banner-mobile@2x.0a5cf12e.png";